<h2 mat-dialog-title>Select Sheet and Column</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="selection-form">
    <mat-form-field appearance="outline">
      <mat-label>Sheet</mat-label>
      <mat-select formControlName="sheetId" (selectionChange)="onSheetChange($event.value)">
        @for (sheet of sheets; track sheet.id) {
          <mat-option [value]="sheet.id">{{ sheet.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (selectedSheetColumns.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>Column</mat-label>
        <mat-select formControlName="columnLetter">
          @for (col of selectedSheetColumns; track col) {
            <mat-option [value]="col">Column {{ col }}</mat-option>
          }
        </mat-select>
        <mat-hint>Select which column contains your data</mat-hint>
      </mat-form-field>
    }

    <mat-form-field appearance="outline">
      <mat-label>Start Row</mat-label>
      <input matInput type="number" formControlName="startRow" min="1" />
      <mat-hint>Row 1 = header, Row 2 = first data row</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="form.invalid">Confirm</button>
</mat-dialog-actions>
